import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import Button from '../../../components/form/button';
import Input from '../../../components/form/input';
import Modal from '../../../components/modal/default';
import useAuth from '../../../hooks/auth';
import { logger } from '../../../utils/logger';
import styles from './styles.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const UsersForgotView: FC = () => {
  const [tried, setTried] = useState(false);
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const { logout, forgot, isLoading } = useAuth();

  // clear out any current auth state, they are trying to reset
  useEffect(() => logout(), []);

  const handleSetEmail = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleForgot = async () => {
    try {
      setTried(true);
      await forgot({ email });
      setSuccess(true);
    } catch (err: any) {
      err.message = `Forgot error: ${err?.message}`;
      logger.error(err);
    }
  };

  const getIsOpen = (): boolean => {
    // if forgot returned an error
    if (!isLoading && tried && !success) return true;

    // upon success, show result
    if (!isLoading && success) return true;

    return false;
  };

  const getModalTitle = (): string => {
    // if forgot returned an error
    if (tried && !success) return 'Server Error';

    // upon success
    if (tried && success) return 'Success';

    return '';
  };

  const getModalContent = () => {
    // if forgot returned an error
    if (tried && !success)
      return (
        <div className={styles.notifyContainer}>
          <div className={styles.notifyIcon}>
            <FontAwesomeIcon icon={faExclamationCircle as IconProp} color="red" />
          </div>
          <div className={styles.notifyText}>
            There was an error processing your request. Please try again.
          </div>
        </div>
      );

    return (
      <div className={styles.notifyContainer}>
        <div className={styles.notifyIcon}>
          <FontAwesomeIcon icon={faCheckCircle as IconProp} color="green" />
        </div>
        <div className={styles.notifyText}>
          Request sent successfully. If you have a Limbic account, you will receive an email with a
          link to reset your account. You may close this window.
        </div>
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <Input.Field
        className={styles.input}
        placeholder="Email address"
        value={email}
        onChange={handleSetEmail}
        disabled={isLoading}
      />

      <div className="buttons">
        <Button
          variant="dark"
          type="submit"
          onClick={handleForgot}
          disabled={isLoading}
          isLoading={isLoading}
          dot="green">
          Reset Account
        </Button>
      </div>

      <Modal
        isOpen={getIsOpen()}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        onClose={noop}
        title={getModalTitle()}
        contentProps={{}}
        style={{}}>
        {getModalContent()}
      </Modal>
    </div>
  );
};

export default UsersForgotView;
